import { pathOf, routePath } from "../../shared/routes/index.js";
import { NAV_LINKS } from "./links";
import { PAGES } from "./pages";
import { SECTION_ORDER } from "./sections";

const PAGE_BY_ID = new Map(PAGES.map((page) => [page.id, page]));

const scopeOf = (id) => id.split(".")[0];

const shopParams = (id, { activeInfluencer }) =>
  scopeOf(id) === "shop" ? { shop: activeInfluencer.route } : {};

const REST = /\/\*$/u;

/* React Router v5 compiles a trailing "/*" so that it needs a segment after the slash. */
export const routerPathOf = (id) => pathOf(id).replace(REST, "");

export const isExactRoute = (id) => !REST.test(pathOf(id));

export const pagePathFor = (id, ctx) => routePath(id, shopParams(id, ctx));

export const canOpen = (id, ctx) => Boolean(PAGE_BY_ID.get(id)?.guard(ctx));

export const pagesFor = (scope, ctx) =>
  PAGES.filter((page) => scopeOf(page.id) === scope && page.guard(ctx));

export const fallbackFor = (scope, ctx) =>
  scope === "shop"
    ? routePath("shop.home", shopParams("shop.home", ctx))
    : scope === "admin" && canOpen("admin.index", ctx)
    ? routePath("admin.index")
    : routePath("account.orders");

export const labelOf = ({ label }, ctx) =>
  typeof label === "function" ? label(ctx) : label;

const pageLink =
  (ctx) =>
  ({ id, nav }) => ({
    id,
    section: nav.section,
    label: labelOf(nav, ctx),
    iconName: nav.iconName,
    path: pagePathFor(id, ctx),
    exact: nav.exact,
    badge: nav.badge,
  });

const otherLink = ({ id, label, iconName, section, href, newTab, routeId }) =>
  href
    ? { id, section, label, iconName, href, newTab }
    : { id, section, label, iconName, path: routePath(routeId) };

const withoutSection = ({ section: _section, ...link }) => link;

export const navFor = (context, ctx) => {
  const links = [
    ...PAGES.filter(
      ({ nav, guard }) => nav?.contexts.includes(context) && guard(ctx),
    ).map(pageLink(ctx)),
    ...NAV_LINKS.filter(({ contexts }) => contexts.includes(context)).map(
      otherLink,
    ),
  ];

  return SECTION_ORDER.map((section) => ({
    section,
    links: links.filter((link) => link.section === section).map(withoutSection),
  })).filter(({ links: sectionLinks }) => sectionLinks.length > 0);
};

export const shopFlags = ({ influencerId, route, kind, noShopEditor }) => ({
  influencerId,
  route,
  isGroupShop: kind === "collection",
  isAgentShop: kind === "agent",
  isTcShop: kind === "talentCoordinator",
  hasNoShopEditor: Boolean(noShopEditor),
});

const shopPageAt = (section) =>
  PAGES.find(
    ({ id }) =>
      scopeOf(id) === "shop" && pathOf(id) === `/dashboard/:shop/${section}`,
  );

export const switchTarget = ({ currentPath, shop, ctx }) => {
  const target = shopFlags(shop);
  const [, , , section] = currentPath.split("/");
  const page = section ? shopPageAt(section) : undefined;
  const open = page?.guard({ ...ctx, activeInfluencer: target });

  return routePath(open ? page.id : "shop.home", { shop: target.route });
};
